// frontend/src/pages/TermsPolicy.js  (Part 1/4)
import React from 'react'
import { Container } from 'react-bootstrap'
import '../custom.css'

export default function TermsPolicy () {
  return (
    <>
      {/* Hero */}
      <section className='full-bleed py-5 bg-primary-soft text-center'>
        <Container style={{ maxWidth: 960 }}>
          <h1 className='display-5 fw-bold mb-3'>Terms&nbsp;of&nbsp;Service</h1>
          <p className='lead mb-0'>Last modified: August&nbsp;1,&nbsp;2025</p>
        </Container>
      </section>

      {/* Body */}
      <section className='py-5'>
        <Container style={{ maxWidth: 960 }}>

          {/* Intro */}
          <h2 className='fw-bold'>Greatly Social Terms of Service</h2>
          <p><strong>Last Modified:</strong> August&nbsp;1,&nbsp;2020<br/>
             <strong>Effective Date:</strong> August&nbsp;1,&nbsp;2020</p>
          <p><strong>PLEASE READ THESE TERMS CAREFULLY.</strong> By accessing or using any products, software,
             mobile applications, websites or other services (collectively, the <em>“Services”</em>) provided by
             Lately Social, LLC&nbsp;d/b/a <strong>Greatly Social</strong> (<q>Greatly Social</q>, <q>we</q>,
             <q>our</q>, or <q>us</q>), you (<q>you</q>, <q>your</q>, or <em>“Customer”</em>) agree to be bound
             by this Terms&nbsp;of&nbsp;Service Agreement (the <em>“Agreement”</em>).</p>
          <blockquote className='alert alert-warning'>
            These terms contain a binding arbitration clause and class-action waiver in § 17. Please review carefully.
          </blockquote>

          {/* === 1. Acceptance & Eligibility === */}
          <h3 className='fw-bold mt-4'>1.&nbsp;Acceptance &amp; Eligibility</h3>
          <p><strong>1.1&nbsp;Legal Capacity.</strong> You affirm that you are at least 18 years of age, have the legal
             capacity to enter into this Agreement, and will use the Services only for business or professional
             purposes.</p>
          <p><strong>1.2&nbsp;Authority.</strong> If you use the Services on behalf of an organization, you represent
             that you have authority to bind that entity; the term <em>“you”</em> includes the entity and its
             Authorized Users.</p>
          <p><strong>1.3&nbsp;Binding Agreement.</strong> By creating an account, clicking “I Agree,” or otherwise using
             the Services, you accept this Agreement and our <strong>Privacy&nbsp;Policy</strong> (collectively, the
             <em>“Terms”</em>). If you do not agree, do not access or use the Services.</p>

          {/* === 2. Changes to These Terms === */}
          <h3 className='fw-bold mt-4'>2.&nbsp;Changes to These Terms</h3>
          <p>We may modify the Terms at any time by posting an updated version on our website or within the Services.
             The “Last Modified” date will reflect the effective date of the updated Terms. Your continued use of the
             Services after the effective date constitutes acceptance. Material changes will be notified via email or
             in-app notice at our discretion.</p>

          {/* === 3. Accounts & Security === */}
          <h3 className='fw-bold mt-4'>3.&nbsp;Accounts &amp; Security</h3>
          <p><strong>3.1&nbsp;Account Credentials.</strong> You are solely responsible for safeguarding account
             credentials and for all activities under your account.</p>
          <p><strong>3.2&nbsp;Authorized Users.</strong> You may permit employees, contractors, or other agents
             (“Authorized Users”) to use the Services; you remain liable for their compliance with these Terms.</p>
          <p><strong>3.3&nbsp;Accuracy of Information.</strong> You must maintain accurate and complete account
             information and promptly update any changes.</p>

          {/* === 4. License & Acceptable Use === */}
          <h3 className='fw-bold mt-4'>4.&nbsp;License &amp; Acceptable Use</h3>
          <p><strong>4.1&nbsp;Limited License.</strong> Subject to these Terms, we grant you a personal, non-exclusive,
             non-transferable, revocable license to access and use the Services for your internal business purposes.</p>
          <p><strong>4.2&nbsp;Restrictions.</strong> You agree not to (a) copy, modify, decompile, reverse-engineer,
             disassemble, or create derivative works of the Services; (b) sell, sublicense, lease, or otherwise
             commercially exploit the Services; (c) use automated means such as scraping, crawling, or bots without our
             prior written consent; (d) upload or transmit viruses or malicious code; (e) use the Services in violation
             of any laws or third-party rights; or (f) attempt to gain unauthorized access to the Services or related
             systems.</p>
          <p><strong>4.3&nbsp;Acceptable Use Rules.</strong> Your use of the Services must also comply with our&nbsp;
            <a href='https://greatlysocial.com/acceptable-use' target='_blank' rel='noopener noreferrer'>
              Acceptable Use Rules</a> (or successor URL).</p>

          {/* === 5. Third-Party Services & APIs === */}
          <h3 className='fw-bold mt-4'>5.&nbsp;Third-Party Services &amp; APIs</h3>
          <p><strong>5.1&nbsp;Integration.</strong> The Services may interoperate with social networks and other
             third-party platforms (“Third-Party Services”). We do not control and are not responsible for them.</p>
          <p><strong>5.2&nbsp;API Changes.</strong> Third-Party Services may alter or terminate their APIs at any time.
             We may modify or discontinue related features without liability.</p>
          <p><strong>5.3&nbsp;Your Responsibility.</strong> Your use of Third-Party Services is governed solely by your
             agreement with the provider. We disclaim all liability arising from Third-Party Services, account
             suspensions, or policy violations.</p>

          {/* === 6. Content === */}
          <h3 className='fw-bold mt-4'>6.&nbsp;Content</h3>
          <p><strong>6.1&nbsp;Customer Content.</strong> “Customer Content” means content you or your Authorized Users
             submit to the Services. You retain ownership of Customer Content and grant Greatly Social a worldwide,
             non-exclusive, royalty-free license to host, use, reproduce, modify, display, and distribute Customer
             Content solely to operate and improve the Services.</p>
          <p><strong>6.2&nbsp;Responsibility.</strong> You are solely responsible for Customer Content and warrant that
             you have all necessary rights to post it and that it does not violate any laws or third-party rights.</p>
          <p><strong>6.3&nbsp;Monitoring.</strong> We may monitor, remove, or refuse to publish any Customer Content at
             our sole discretion but have no obligation to do so.</p>

          {/* === 7. Intellectual Property === */}
          <h3 className='fw-bold mt-4'>7.&nbsp;Intellectual Property</h3>
          <p><strong>7.1&nbsp;Our Property.</strong> The Services, including all software, logos, trademarks, text,
             graphics, and other materials (“Greatly Social Content”) are owned or licensed by Greatly Social and
             protected by intellectual-property laws. Except for the limited license in § 4.1, no rights are granted to
             you.</p>
          <p><strong>7.2&nbsp;Feedback.</strong> You grant us a perpetual, irrevocable, royalty-free license to use any
             suggestions, comments, or other feedback provided about the Services.</p>

          {/* === 8. Fees, Trials & Payment === */}
          <h3 className='fw-bold mt-4'>8.&nbsp;Fees, Trials &amp; Payment</h3>
          <p><strong>8.1&nbsp;Fees and No-Refund Policy.</strong> All subscription, add-on, and usage fees are
             <em>immediately due, non-cancellable, and non-refundable</em>—including for partial billing periods, unused
             Services, account inactivity, downgrades, or accidental / forgotten renewals. <strong>You are solely
             responsible for monitoring your renewal dates and cancelling in advance if you no longer wish to be
             billed.</strong> To the maximum extent permitted by law, you expressly waive any statutory “cooling-off” or
             withdrawal right that may otherwise apply to digital or subscription services.</p>
          <p><strong>8.2&nbsp;Trials.</strong> Free trials convert to the selected paid plan on the first day following
             the trial unless you cancel before the trial ends. Once converted, fees become non-refundable under § 8.1.</p>
          <p><strong>8.3&nbsp;Auto-Renewal.</strong> Paid subscriptions renew automatically for successive periods equal
             to the initial term at the then-current rates unless you cancel through the in-product billing portal
             before the renewal date.</p>
          <p><strong>8.4&nbsp;Taxes.</strong> Fees exclude all applicable taxes, which you are responsible to pay.</p>
          <p><strong>8.5&nbsp;Payment Method &amp; Retries.</strong> If a charge is declined, we may retry the payment
             method up to three&nbsp;(3) times over a seven-day period. If payment remains unsuccessful, we may suspend
             or terminate access without further notice.</p>
          <p><strong>8.6&nbsp;Non-Payment &amp; Chargebacks.</strong> Any reversed, disputed, or fraudulent payment will
             result in immediate suspension. You remain liable for the original fees plus any chargeback costs,
             interest, and reasonable collection expenses.</p>

          {/* === Part 1 ends — continue with Part 2 === */}
          {/* === 9. Cancellation & Termination === */}
          <h3 className='fw-bold mt-4'>9.&nbsp;Cancellation &amp; Termination</h3>
          <p><strong>9.1&nbsp;By You (Self-Serve).</strong> You may cancel your subscription at any time <em>solely</em>
             by using the in-product billing portal. Email, chat, or support tickets do not constitute cancellation.
             Cancellation becomes effective at the end of the current paid term; <strong>no refunds or credits</strong>
             will be issued for the remaining portion of the term.</p>
          <p><strong>9.2&nbsp;By Us.</strong> We may suspend or terminate your access immediately for violation of these
             Terms or any reason, with or without notice. If we terminate for our convenience and you are not in breach,
             we will refund any prepaid fees covering the remainder of the current term after the effective termination
             date; otherwise, <strong>no refund</strong> is due.</p>

          {/* === 10. Disclaimer of Warranties === */}
          <h3 className='fw-bold mt-4'>10.&nbsp;Disclaimer of Warranties</h3>
          <p><strong>10.1&nbsp;General.</strong> THE SERVICES ARE PROVIDED “AS IS” AND “AS AVAILABLE” WITHOUT WARRANTIES
             OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
             NON-INFRINGEMENT, OR AVAILABILITY.</p>
          <p><strong>10.2&nbsp;Posting Reliability.</strong> Social networks may throttle, rate-limit, or reject scheduled
             posts; posting times are <em>best-effort only</em> and delays or failures do not constitute a service breach.</p>
          <p><strong>10.3&nbsp;AI &amp; Automation.</strong> Any AI-generated captions, hashtags, or recommendations are
             provided for convenience only and may be inaccurate or inappropriate. You are solely responsible for
             reviewing and approving content before publication.</p>
          <p><strong>10.4&nbsp;No Professional Advice.</strong> Information provided by the Services does not constitute
             legal, financial, or marketing advice. You should consult professionals before acting on such information.</p>

          {/* === 11. Limitation of Liability === */}
          <h3 className='fw-bold mt-4'>11.&nbsp;Limitation of Liability</h3>
          <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT WILL GREATLY SOCIAL OR ITS AFFILIATES, DIRECTORS,
             EMPLOYEES, AGENTS, SUPPLIERS, OR LICENSORS (COLLECTIVELY, <q>GREATLY SOCIAL PARTIES</q>) BE LIABLE FOR ANY
             INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES, OR FOR ANY LOSS OF PROFITS,
             REVENUE, DATA, OR GOODWILL, ARISING FROM OR RELATED TO THE SERVICES OR THESE TERMS, EVEN IF ADVISED OF THE
             POSSIBILITY.</p>
          <p>THE AGGREGATE LIABILITY OF THE GREATLY SOCIAL PARTIES FOR ALL CLAIMS RELATING TO THE SERVICES OR THESE
             TERMS WILL NOT EXCEED THE GREATER OF (A) USD $100 OR (B) THE TOTAL AMOUNT PAID BY YOU TO GREATLY SOCIAL FOR
             THE SERVICES IN THE THREE (3) MONTHS PRECEDING THE EVENT GIVING RISE TO LIABILITY.</p>

          {/* === 12. Indemnification === */}
          <h3 className='fw-bold mt-4'>12.&nbsp;Indemnification</h3>
          <p>You will indemnify, defend, and hold harmless the Greatly Social Parties from any claims, damages,
             liabilities, and costs (including reasonable attorneys’ fees) arising from (a) Customer Content;
             (b) your violation of these Terms or any laws; or (c) your use of Third-Party Services.</p>

          {/* === 13. Confidentiality === */}
          <h3 className='fw-bold mt-4'>13.&nbsp;Confidentiality</h3>
          <p>Any non-public information disclosed by Greatly Social remains confidential; you must use reasonable measures
             to protect it and may use it only in connection with the Services.</p>

          {/* === 14. Export & Compliance === */}
          <h3 className='fw-bold mt-4'>14.&nbsp;Export &amp; Compliance</h3>
          <p>You will not access or use the Services in violation of export-control laws or if you are located in an
             embargoed country or are on any sanctions list.</p>

          {/* === 15. Force Majeure === */}
          <h3 className='fw-bold mt-4'>15.&nbsp;Force Majeure</h3>
          <p>Greatly Social is not liable for any delay or failure to perform resulting from causes beyond its reasonable
             control, including natural disasters, war, terrorism, labor disputes, Internet interruptions, or government
             actions.</p>

          {/* === 16. Assignment === */}
          <h3 className='fw-bold mt-4'>16.&nbsp;Assignment</h3>
          <p>You may not assign or transfer these Terms without our prior written consent. We may assign our rights and
             obligations without restriction.</p>

          {/* === Part 2 ends — continue with Part 3 === */}
          {/* === 17. Governing Law & Dispute Resolution === */}
          <h3 className='fw-bold mt-4'>17.&nbsp;Governing Law &amp; Dispute Resolution</h3>
          <p><strong>17.1&nbsp;Governing Law.</strong> These Terms are governed by the laws of the State of Florida,
             USA, without regard to conflict-of-law rules.</p>
          <p><strong>17.2&nbsp;Binding Arbitration.</strong> Any dispute arising out of or relating to the Services or
             these Terms will be resolved solely and exclusively by confidential, binding arbitration conducted in
             Tampa, Florida, before a single arbitrator under the Commercial Arbitration Rules of the American
             Arbitration Association. Judgment on the award may be entered in any court of competent jurisdiction.</p>
          <p><strong>17.3&nbsp;Class-Action Waiver.</strong> Disputes must be brought on an individual basis; class,
             collective, or representative actions are not permitted.</p>
          <p><strong>17.4&nbsp;Equitable Relief.</strong> Nothing prevents either party from seeking injunctive relief in
             any court of competent jurisdiction to protect its intellectual property or Confidential Information.</p>

          {/* === 18. Severability & Waiver === */}
          <h3 className='fw-bold mt-4'>18.&nbsp;Severability &amp; Waiver</h3>
          <p>If any provision of these Terms is held unenforceable, the remaining provisions will remain in effect.
             Failure to enforce any right or provision will not constitute a waiver of such right or provision.</p>

          {/* === 19. Entire Agreement === */}
          <h3 className='fw-bold mt-4'>19.&nbsp;Entire Agreement &amp; Order of Precedence</h3>
          <p>These Terms constitute the entire agreement between you and Greatly Social regarding the Services and
             supersede all prior or contemporaneous agreements. In the event of conflict, these Terms prevail over any
             purchase order or other document.</p>

          {/* === 20. Contact === */}
          <h3 className='fw-bold mt-4'>20.&nbsp;Contact</h3>
          <p>For questions regarding these Terms, please contact us at&nbsp;
             <a href='mailto:legal@greatlysocial.com'>legal@greatlysocial.com</a>.</p>

          {/* === 21. DMCA === */}
          <h3 className='fw-bold mt-4'>21.&nbsp;Copyright Complaints &amp; Repeat Infringers (DMCA)</h3>
          <p>If you believe material on the Services infringes your copyright, please send a written notice to
             legal@greatlysocial.com with the information required under 17 U.S.C. §512(c)(3). Upon receipt, we may
             remove or disable access to the material. Repeat infringers’ accounts will be terminated in appropriate
             circumstances.</p>

          {/* === 22. Fair Use Limits === */}
          <h3 className='fw-bold mt-4'>22.&nbsp;Fair Use Limits</h3>
          <p>Use of the Services is subject to reasonable volume and rate limits associated with your subscription tier.
             Excessive or abnormal usage (e.g., disproportionate posting rates, connection counts, or API calls) may
             result in temporary throttling, additional fees, or suspension until usage is reduced.</p>

          {/* === 23. Data Retention & Deletion === */}
          <h3 className='fw-bold mt-4'>23.&nbsp;Data Retention &amp; Deletion</h3>
          <p>We are not an archival service. Customer Content, logs, and backups may be irretrievably deleted
             30 days after account cancellation or termination. We have no liability for deleted data.</p>

          {/* === 24. Beta Services === */}
          <h3 className='fw-bold mt-4'>24.&nbsp;Beta Services</h3>
          <p>We may offer experimental or pre-release features (“Beta Services”). Beta Services are provided
             <em>as-is</em>, may change or discontinue at any time, and are excluded from any SLA or support
             commitment.</p>

          {/* === Part 3 ends — continue with Part 4 === */}
          {/* === 25. AI & Automation Disclaimer === */}
          <h3 className='fw-bold mt-4'>25.&nbsp;AI &amp; Automation Disclaimer (Additional)</h3>
          <p>AI outputs may include errors, biases, or third-party content. You are responsible for verifying legality,
             accuracy, and suitability before use. Greatly Social disclaims all liability arising from AI-generated
             outputs.</p>

          {/* === 26. Promotions & Trial Pricing === */}
          <h3 className='fw-bold mt-4'>26.&nbsp;Promotions &amp; Trial Pricing</h3>
          <p>Unless expressly stated otherwise, promotional discounts, coupon codes, or introductory offers apply only
             to the first subscription term. Subsequent renewals will be billed at the then-current standard rate.</p>

          {/* === 27. Publicity Rights === */}
          <h3 className='fw-bold mt-4'>27.&nbsp;Publicity Rights</h3>
          <p>Unless you notify us in writing to the contrary, you grant Greatly Social a limited, worldwide, royalty-free
             license to identify you as a customer and to display your name, logo, and trademark on our website,
             social-media channels, investor materials, and customer lists. You may withdraw this permission at any time
             by emailing <a href='mailto:legal@greatlysocial.com'>legal@greatlysocial.com</a>; upon receipt, we will make
             commercially reasonable efforts to remove references within thirty (30) days.</p>

          {/* === 28. Aggregated & Anonymized Analytics === */}
          <h3 className='fw-bold mt-4'>28.&nbsp;Aggregated &amp; Anonymized Analytics</h3>
          <p>We may compile statistical or performance information related to the operation of the Services, provided
             such information is aggregated and de-identified (“Aggregated Data”). Aggregated Data may be used by Greatly
             Social for industry benchmarking, research, marketing, and product improvement. Aggregated Data will not
             identify you or any individual.</p>

          {/* === 29. Service Availability & Maintenance === */}
          <h3 className='fw-bold mt-4'>29.&nbsp;Service Availability &amp; Maintenance Window</h3>
          <p><strong>29.1&nbsp;Availability Goal.</strong> We target reasonable uptime but do not guarantee uninterrupted
             availability.</p>
          <p><strong>29.2&nbsp;Planned Maintenance.</strong> Routine maintenance may occur during the standard window of
             02:00 – 05:00 UTC and may result in temporary unavailability.</p>
          <p><strong>29.3&nbsp;Emergency Maintenance.</strong> We may perform emergency maintenance at any time to
             mitigate immediate risks. Downtime arising from planned or emergency maintenance is exempt from any refund,
             credit, or breach claim.</p>

          {/* === 30. U.S. Government Restricted Rights === */}
          <h3 className='fw-bold mt-4'>30.&nbsp;U.S. Government Restricted Rights</h3>
          <p>The Services and documentation are “commercial computer software” and “commercial computer software
             documentation” under FAR 12.212 and DFARS 227.7202. Use, duplication, or disclosure by the U.S. Government
             is subject to those restrictions.</p>

          {/* === 31. Mobile App-Store Beneficiary === */}
          <h3 className='fw-bold mt-4'>31.&nbsp;Mobile App-Store Third-Party Beneficiary</h3>
          <p>If you access the Services via a mobile app obtained through the Apple App Store or Google Play Store, you
             acknowledge that Apple Inc. or Google LLC (as applicable) and their subsidiaries are third-party
             beneficiaries of these Terms and may enforce them. Neither Apple nor Google is responsible for support,
             maintenance, or warranty regarding the mobile application.</p>

          {/* === 32. Data Processing Addendum === */}
          <h3 className='fw-bold mt-4'>32.&nbsp;Data Processing Addendum (DPA)</h3>
          <p>Where Greatly Social processes personal data on your behalf, the terms of our&nbsp;
             <a href='https://greatlysocial.com/dpa' target='_blank' rel='noopener noreferrer'>Data Processing
             Addendum</a> are incorporated by reference and form part of these Terms.</p>

          {/* === 33. AI-Powered Services Terms === */}
          <h3 className='fw-bold mt-4'>33.&nbsp;AI-Powered Services Terms</h3>
          <p>Your use of any AI-powered or machine-learning features of the Services is also governed by our&nbsp;
             <a href='https://greatlysocial.com/ai-terms' target='_blank' rel='noopener noreferrer'>AI Services Terms</a>.
             In the event of a conflict, the AI Services Terms control with respect to AI features.</p>

          {/* === Copyright === */}
          <p className='mt-5 mb-0 text-center'>
            © 2025 Lately Social, LLC d/b/a Greatly Social. All rights reserved.
          </p>

        </Container>
      </section>
    </>
  )
}
